import React, { Component } from 'react';
import StripeCheckout from 'react-stripe-checkout';
import { API } from 'aws-amplify';

export default class PaymentButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stripeKey: 'pk_live_fI81w7B6cyyWgSYF73lm8vVl'
    };
  }

  onToken = async token => {
    console.log(token);
    this.props.startProcessingCallback();
    API.post('va-estimator', '/va-estimator/' + this.props.url, { body: token })
      .then(result => {
        this.props.successCallback(result);
      })
      .catch(error => {
        this.props.failureCallback(error);
      });
  };

  render() {
    return (
      <StripeCheckout
        token={this.onToken}
        stripeKey={this.state.stripeKey}
        name="Personal Account Upgrade"
        description="Digimasters"
        amount={this.props.amount}
        currency="GBP"
        billingAddress
        zipCode
        locale="auto"
        email={this.props.username}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/PaymentButton.js